import { getTokenString } from '../getTokenString/getTokenString';
export function replaceTokensWithTags(content, variables) {
    const flattenedVariableNames = variables.flatMap((category) => category.items);
    return content.replace(/{{([^:]*:)?([^}]+)}}/g, (group, scope = '', variableName = '') => {
        const completeMatch = scope + variableName;
        const nameMatch = flattenedVariableNames.find((vName) => vName.name === completeMatch);
        if (nameMatch) {
            return getTokenString(completeMatch, nameMatch.content);
        }
        return group;
    });
}
